var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('td',[(_vm.action)?_c('span',{staticClass:"btn-action-link",on:{"click":function($event){return _vm.action()}}},[_c('span',{staticClass:"circle ml-2",class:_vm.getStatusColor()})]):_c('span',[_c('span',{staticClass:"circle ml-2",class:_vm.getStatusColor()})])])
}
var staticRenderFns = []

export { render, staticRenderFns }